import React from 'react';
import { TableRow, TableCell } from '@mui/material';

interface AuditTableEmptyProps {
  colSpan: number;
}

const AuditTableEmpty: React.FC<AuditTableEmptyProps> = ({ colSpan }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="audit-table__cell--no-data">
        <p className="text-align-center">No audit data found for the selected date range.</p>
      </TableCell>
    </TableRow>
  );
};

export default AuditTableEmpty; 